import { Box, Grid, Typography } from '@mui/material';
import { ResponsiveBar } from '@nivo/bar';
import { Surface } from '../../../components/primitives';
import ChartSection from '../shared/ChartSection';
import ChartTooltip from '../shared/ChartTooltip';
import useNivoTheme from '../shared/useNivoTheme';

export default function BeatTheMarket({ data }) {
    const { theme, colors } = useNivoTheme();
    if (!data) return null;

    return (
        <ChartSection id="beat-market" title="Do members of Congress beat the stock market?" takeaway={`${data.pct_positive}% of Congress members with enough trades to measure have beaten the S\u00a0&\u00a0P 500 — but the average alpha of ${data.avg_alpha > 0 ? '+' : ''}${data.avg_alpha}% suggests most of the edge is concentrated in a small group of skilled traders.`}>
            <Grid container spacing={2} sx={{ mb: 2 }}>
                {[
                    { label: 'Beat the Market', value: data.pct_positive + '%', color: 'success.main', sub: `${data.positive_alpha} of ${data.total_members} members` },
                    { label: 'Avg Alpha', value: (data.avg_alpha > 0 ? '+' : '') + data.avg_alpha + '%', color: data.avg_alpha >= 0 ? 'success.main' : 'error.main', sub: 'vs S&P 500' },
                    { label: 'Underperform', value: data.negative_alpha, color: 'error.main', sub: 'members lose to SPY' },
                ].map((s, i) => (
                    <Grid item xs={4} key={i}>
                        <Surface variant="subtle" padding={2}>
                            <Typography variant="overline" sx={{ color: 'text.muted' }}>{s.label}</Typography>
                            <Typography sx={{ fontSize: '1.5rem', fontWeight: 700, color: s.color, fontFamily: t => t.typography.fontFamilyMono }}>{s.value}</Typography>
                            <Typography variant="caption" sx={{ color: 'text.muted' }}>{s.sub}</Typography>
                        </Surface>
                    </Grid>
                ))}
            </Grid>
            <Box sx={{ height: 280 }}>
                <ResponsiveBar
                    data={data.histogram} keys={['count']} indexBy="bucket"
                    margin={{ top: 10, right: 20, bottom: 40, left: 45 }}
                    padding={0.2} borderRadius={2} enableLabel={false}
                    colors={({ data: d }) => d.bucket >= 0 ? colors.success : colors.error}
                    axisBottom={{ format: v => v + '%', legend: 'Alpha vs S&P 500', legendPosition: 'middle', legendOffset: 32 }}
                    axisLeft={{ legend: 'Members', legendPosition: 'middle', legendOffset: -35 }}
                    tooltip={({ data: d, color }) => (
                        <ChartTooltip
                            title={`${d.bucket >= 0 ? '+' : ''}${d.bucket}% bucket`}
                            rows={[{ label: 'Members', value: d.count, color }]}
                        />
                    )}
                    theme={theme}
                />
            </Box>
        </ChartSection>
    );
}
